module.exports = __webpack_public_path__ + "static/media/urbangoo18.afd355ec.webp";